import React, { Fragment, useState, useEffect, useRef } from 'react'
import { useDebouncedEffect } from '@/utils/useDebouncedEffect'
import { EyeIcon } from '@heroicons/react/solid'
import Pagination from '@/shared/Pagination'
import Loading from '@/shared/Loading'
import { useGlobalState } from '@/state'
import useQuery from '@/hooks/useQuery'
import Card from '@/shared/Card'
import PublicProjectRow from '@/pages/Users/PublicProfile/PublicProjectRow'

const NoProjects = () => {
  return (
    <span>
      <div className="relative block w-full border-2 border-gray-300 border-dashed rounded-lg p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cccblue" >
        <EyeIcon className="mx-auto h-12 w-12 text-gray-400" />
        <span className="mt-2 block text-sm font-medium text-gray-900 dark:text-gray-300">No public projects yet.</span>
      </div>
    </span>
  )
}

const PublicProjects = () => {
  const [profileContainer, setProfileContainer] = useGlobalState('profileContainer')
  const [meta, setMeta] = useState({})
  const { getRequest } = useQuery()
  const { user, projects } = profileContainer
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(1)
  const [contains, setContains] = useState('')
  const scrollRef = useRef(null)

  useDebouncedEffect(() => { fetchData() }, 200, [contains])
  useEffect(() => { fetchData() }, [page])

  const fetchData = () => {
    setLoading(true)
    const data = {
      contains: contains,
      page: contains.length > 0 ? 1 : page
    }
    getRequest(`/api/v3/users/${user.id}/projects`, data, (err, jsonData) => {
      setLoading(false)
      if (err) { /* hooks */ return }

      setProfileContainer({
        ...profileContainer,
        projects: jsonData.projects
      })
      setMeta(jsonData.meta)
    })
  }

  return <>
    <Card light title='Projects'>
      <>
        { user.projectsCount > 0 && <div className='pb-3' ref={scrollRef}>
          <input name='contains' type="search" onChange={(e) => setContains(e.target.value)} placeholder="Search by project name" aria-label='Search projects' />
        </div> }
        { !loading && projects.length === 0 && <NoProjects /> }
        <ul className="space-y-3">
          {projects.map((project) => (
            <PublicProjectRow key={`pubpro${project.id}`} project={project} />
          ))}
        </ul>
        { loading && <Loading /> }
        { projects.length > 0 && <div className='mt-3'><Pagination meta={meta} callback={setPage} scrollRef={scrollRef} /></div> }
      </>
    </Card>

  </>
}

export default PublicProjects
